import { render, staticRenderFns } from "./Operations.vue?vue&type=template&id=065f36a0&scoped=true&"
import script from "./Operations.vue?vue&type=script&lang=js&"
export * from "./Operations.vue?vue&type=script&lang=js&"
import style0 from "./Operations.vue?vue&type=style&index=0&id=065f36a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f36a0",
  null
  
)

export default component.exports